import { render } from "./AdListView.vue?vue&type=template&id=99904ad2"
import script from "./AdListView.vue?vue&type=script&lang=js"
export * from "./AdListView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__